import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // --- ATELIER STYLES ---

  // Desktop Links: Minimalist, Uppercase, Tracking
  const navLinkClass = ({ isActive }) =>
    `text-xs uppercase tracking-[0.2em] pb-1 border-b transition-all font-sans ${
      isActive
        ? 'text-stone-900 border-stone-900 font-medium' // Active: Charcoal
        : 'text-stone-400 border-transparent hover:text-stone-900' // Inactive: Grey to Charcoal
    }`;

  // Mobile Links: Clean list items
  const mobileNavLinkClass = ({ isActive }) =>
    `block w-full text-left px-6 py-4 border-l-4 transition-colors font-sans text-sm uppercase tracking-widest ${
      isActive
        ? 'bg-stone-100 border-stone-900 text-stone-900 font-medium' // Active
        : 'border-transparent text-stone-500 hover:bg-stone-50 hover:text-stone-900' // Inactive
    }`;

  return (
    <>
      {/* Top Accent Line */}
      <div className="w-full h-1 bg-stone-900"></div>

      {/* Header Container - Uses 'justify-center' to center the tabs */}
      <header className="bg-[#F9F9F7] h-24 flex items-center justify-center border-b border-stone-200 relative px-6">

        {/* 1. Logo Section - ABSOLUTE LEFT (Pins it to the start) */}
        <NavLink to="/" onClick={closeMenu} className="absolute left-6 z-20">
          <img
            src="/museome_logo_v3.png"
            alt="Museome"
            className="h-10 object-contain opacity-90 hover:opacity-100 transition-opacity"
          />
        </NavLink>

        {/* 2. Desktop Navigation - NATURALLY CENTERED */}
        <nav className="hidden md:flex gap-12 items-center">
          <NavLink to="/" className={navLinkClass}>
            Gallery
          </NavLink>

          <NavLink to="/chat" className={navLinkClass}>
            Atelier
          </NavLink>

          <NavLink to="/contact" className={navLinkClass}>
            Contact
          </NavLink>
        </nav>

        {/* 3. Mobile Menu Button - ABSOLUTE RIGHT (Pins it to the end) */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-2xl text-stone-900 hover:text-stone-600 focus:outline-none absolute right-6 z-20"
        >
          {menuOpen ? '✕' : '☰'}
        </button>

        {/* 4. Mobile Menu Overlay */}
        {menuOpen && (
          <div className="absolute right-0 top-full w-full md:w-64 bg-white shadow-xl border-t border-stone-100 z-10 animate-fade-in-down">
            <ul className="flex flex-col py-2">
              <li>
                <NavLink to="/" onClick={closeMenu} className={mobileNavLinkClass}>
                  Gallery
                </NavLink>
              </li>
              <li>
                <NavLink to="/chat" onClick={closeMenu} className={mobileNavLinkClass}>
                  Concierge
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" onClick={closeMenu} className={mobileNavLinkClass}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        )}
      </header>
    </>
  );
}

export default Header;